// ============================================================
// 15 PACIENTES MOCK NUEVOS — Viaje del Paciente UC Christus
// Ambulatorio (7), Hospitalario (2), Urgencia (3), Oncológico (1),
// Diálisis (1), Multi-viaje (2)
// ============================================================

// --- AMBULATORIO ---

export const pacienteAnaCardio = {
  rut: "11111111-1",
  nombre: "Ana Cardiología (Amb — Cardiología)",
  edad: 62,
  prevision: "FONASA D",
  centro_habitual: "CM San Joaquín",
  total_eventos: 25,
  resumen_por_ambito: [
    { ambito: "Consulta", count: 6, color: "#06B6D4" },
    { ambito: "Laboratorio", count: 8, color: "#14B8A6" },
    { ambito: "Imagen", count: 4, color: "#10B981" },
    { ambito: "Agenda", count: 5, color: "#8B5CF6" },
    { ambito: "Seguimiento", count: 2, color: "#F43F5E" },
  ],
  eventos: [
    { fecha: "2026-04-10", ambito: "Consulta", descripcion: "Cardiología CMSJ — Control", color: "#06B6D4" },
    { fecha: "2026-04-10", ambito: "Pago", descripcion: "Bono FONASA D — aprobado", color: "#EC4899" },
    { fecha: "2026-03-28", ambito: "Laboratorio", descripcion: "Perfil lipídico + Glicemia", color: "#14B8A6" },
    { fecha: "2026-03-15", ambito: "Imagen", descripcion: "ECG de reposo — CMSJ", color: "#10B981" },
    { fecha: "2026-03-01", ambito: "Agenda", descripcion: "Reserva Cardiología — Web", color: "#8B5CF6" },
    { fecha: "2026-02-20", ambito: "Consulta", descripcion: "Cardiología — Presencial", color: "#06B6D4" },
    { fecha: "2026-02-10", ambito: "Laboratorio", descripcion: "Hemograma + Creatinina", color: "#14B8A6" },
    { fecha: "2026-01-25", ambito: "Imagen", descripcion: "Ecocardiograma transtorácico", color: "#10B981" },
    { fecha: "2026-01-10", ambito: "Consulta", descripcion: "Cardiología — Evaluación inicial", color: "#06B6D4" },
    { fecha: "2025-12-20", ambito: "Laboratorio", descripcion: "Perfil lipídico basal", color: "#14B8A6" },
    { fecha: "2025-12-05", ambito: "Agenda", descripcion: "Cita Cardiología — Atendida", color: "#8B5CF6" },
    { fecha: "2025-11-15", ambito: "Seguimiento", descripcion: "Encuesta NPS respondida (7/10)", color: "#F43F5E" },
  ],
  actividad_mensual: [
    { mes: "Nov 2025", eventos: 3 },
    { mes: "Dic 2025", eventos: 4 },
    { mes: "Ene 2026", eventos: 5 },
    { mes: "Feb 2026", eventos: 4 },
    { mes: "Mar 2026", eventos: 5 },
    { mes: "Abr 2026", eventos: 4 },
  ],
  quiebres: [
    { fecha: "2026-04-10", descripcion: "Lab de control (perfil lipídico) indicado hace >60 días sin resultado", severidad: "alta", accion: "Contacto proactivo WhatsApp para agendar lab" },
  ],
  convenios: [
    { nombre: "FONASA Libre Elección", tipo: "Previsión", vigente: true },
  ],
};

export const pacientePedroOftalmo = {
  rut: "22222222-2",
  nombre: "Pedro Oftalmología (Amb — Oftalmología)",
  edad: 55,
  prevision: "ISAPRE Colmena",
  centro_habitual: "CM Lira",
  total_eventos: 18,
  resumen_por_ambito: [
    { ambito: "Consulta", count: 5, color: "#06B6D4" },
    { ambito: "Imagen", count: 5, color: "#10B981" },
    { ambito: "Agenda", count: 4, color: "#8B5CF6" },
    { ambito: "Financiero", count: 4, color: "#EC4899" },
  ],
  eventos: [
    { fecha: "2026-04-05", ambito: "Consulta", descripcion: "Oftalmología CM Lira — Control anual", color: "#06B6D4" },
    { fecha: "2026-04-05", ambito: "Imagen", descripcion: "Fondo de ojo bilateral", color: "#10B981" },
    { fecha: "2026-04-05", ambito: "Pago", descripcion: "Bono Colmena — aprobado", color: "#EC4899" },
    { fecha: "2026-03-20", ambito: "Agenda", descripcion: "Reserva Oftalmología — Web", color: "#8B5CF6" },
    { fecha: "2026-02-15", ambito: "Consulta", descripcion: "Oftalmología — Presión ocular", color: "#06B6D4" },
    { fecha: "2026-02-15", ambito: "Imagen", descripcion: "Tonometría ocular", color: "#10B981" },
    { fecha: "2026-01-20", ambito: "Consulta", descripcion: "Oftalmología — Agudeza visual", color: "#06B6D4" },
    { fecha: "2026-01-20", ambito: "Imagen", descripcion: "Campimetría computarizada", color: "#10B981" },
    { fecha: "2025-12-10", ambito: "Agenda", descripcion: "Cita Oftalmología — Atendida", color: "#8B5CF6" },
    { fecha: "2025-12-10", ambito: "Pago", descripcion: "Copago Colmena registrado", color: "#EC4899" },
    { fecha: "2025-11-25", ambito: "Consulta", descripcion: "Oftalmología — Primera consulta", color: "#06B6D4" },
  ],
  actividad_mensual: [
    { mes: "Nov 2025", eventos: 2 },
    { mes: "Dic 2025", eventos: 3 },
    { mes: "Ene 2026", eventos: 3 },
    { mes: "Feb 2026", eventos: 3 },
    { mes: "Mar 2026", eventos: 3 },
    { mes: "Abr 2026", eventos: 4 },
  ],
  quiebres: [],
  convenios: [
    { nombre: "PUC - Colmena Egeo", tipo: "ISAPRE", vigente: true },
    { nombre: "Colmena Libre Elección", tipo: "ISAPRE", vigente: true },
  ],
};

export const pacienteMaríaPediatría = {
  rut: "33333333-3",
  nombre: "María Pediatría (Amb — Pediatría)",
  edad: 8,
  prevision: "ISAPRE Banmédica",
  centro_habitual: "Hospital Clínico UC",
  total_eventos: 22,
  resumen_por_ambito: [
    { ambito: "Consulta", count: 7, color: "#06B6D4" },
    { ambito: "Laboratorio", count: 5, color: "#14B8A6" },
    { ambito: "Agenda", count: 6, color: "#8B5CF6" },
    { ambito: "Seguimiento", count: 4, color: "#F43F5E" },
  ],
  eventos: [
    { fecha: "2026-04-08", ambito: "Consulta", descripcion: "Pediatría HCUC — Control sano 8 años", color: "#06B6D4" },
    { fecha: "2026-04-08", ambito: "Pago", descripcion: "Bono Banmédica — aprobado", color: "#EC4899" },
    { fecha: "2026-03-25", ambito: "Laboratorio", descripcion: "Hemograma + Ferritina", color: "#14B8A6" },
    { fecha: "2026-03-15", ambito: "Seguimiento", descripcion: "Vacuna Influenza — aplicada", color: "#F43F5E" },
    { fecha: "2026-03-01", ambito: "Agenda", descripcion: "Reserva Pediatría — App", color: "#8B5CF6" },
    { fecha: "2026-02-18", ambito: "Consulta", descripcion: "Pediatría — Control crecimiento", color: "#06B6D4" },
    { fecha: "2026-02-05", ambito: "Laboratorio", descripcion: "Perfil bioquímico pediátrico", color: "#14B8A6" },
    { fecha: "2026-01-22", ambito: "Consulta", descripcion: "Pediatría — Presencial", color: "#06B6D4" },
    { fecha: "2026-01-10", ambito: "Seguimiento", descripcion: "Vacuna DPT refuerzo — aplicada", color: "#F43F5E" },
    { fecha: "2025-12-15", ambito: "Agenda", descripcion: "Cita Pediatría — Atendida", color: "#8B5CF6" },
    { fecha: "2025-12-01", ambito: "Laboratorio", descripcion: "Hemograma control", color: "#14B8A6" },
    { fecha: "2025-11-20", ambito: "Consulta", descripcion: "Pediatría — Control sano 7 años", color: "#06B6D4" },
  ],
  actividad_mensual: [
    { mes: "Nov 2025", eventos: 3 },
    { mes: "Dic 2025", eventos: 4 },
    { mes: "Ene 2026", eventos: 4 },
    { mes: "Feb 2026", eventos: 3 },
    { mes: "Mar 2026", eventos: 4 },
    { mes: "Abr 2026", eventos: 4 },
  ],
  quiebres: [
    { fecha: "2026-03-15", descripcion: "Vacuna Hepatitis A (2da dosis) atrasada >90 días", severidad: "alta", accion: "Contactar apoderado por WhatsApp para agendar vacuna" },
  ],
  convenios: [
    { nombre: "RED - Banmédica Libre Elección", tipo: "ISAPRE", vigente: true },
  ],
};

export const pacienteCarlosTrauma = {
  rut: "44444444-4",
  nombre: "Carlos Traumatología (Amb — Traumatología)",
  edad: 45,
  prevision: "ISAPRE Cruz Blanca",
  centro_habitual: "CM Escuela Militar",
  total_eventos: 30,
  resumen_por_ambito: [
    { ambito: "Consulta", count: 6, color: "#06B6D4" },
    { ambito: "Imagen", count: 7, color: "#10B981" },
    { ambito: "Agenda", count: 6, color: "#8B5CF6" },
    { ambito: "Seguimiento", count: 8, color: "#F43F5E" },
    { ambito: "Financiero", count: 3, color: "#EC4899" },
  ],
  eventos: [
    { fecha: "2026-04-12", ambito: "Seguimiento", descripcion: "Kinesiología — Sesión 8/12", color: "#F43F5E" },
    { fecha: "2026-04-05", ambito: "Seguimiento", descripcion: "Kinesiología — Sesión 7/12", color: "#F43F5E" },
    { fecha: "2026-03-28", ambito: "Consulta", descripcion: "Traumatología — Control post-infiltración", color: "#06B6D4" },
    { fecha: "2026-03-20", ambito: "Imagen", descripcion: "RX rodilla derecha AP/Lateral", color: "#10B981" },
    { fecha: "2026-03-10", ambito: "Seguimiento", descripcion: "Kinesiología — Sesión 5/12", color: "#F43F5E" },
    { fecha: "2026-02-28", ambito: "Consulta", descripcion: "Traumatología — Infiltración rodilla", color: "#06B6D4" },
    { fecha: "2026-02-15", ambito: "Imagen", descripcion: "Resonancia magnética rodilla derecha", color: "#10B981" },
    { fecha: "2026-02-01", ambito: "Consulta", descripcion: "Traumatología — Evaluación inicial", color: "#06B6D4" },
    { fecha: "2026-01-20", ambito: "Imagen", descripcion: "RX rodilla derecha — primera consulta", color: "#10B981" },
    { fecha: "2026-01-10", ambito: "Agenda", descripcion: "Reserva Traumatología — Web", color: "#8B5CF6" },
    { fecha: "2025-12-15", ambito: "Pago", descripcion: "Presupuesto kinesiología aprobado Cruz Blanca", color: "#EC4899" },
    { fecha: "2025-11-28", ambito: "Consulta", descripcion: "Med Familiar — Derivación a traumatología", color: "#06B6D4" },
  ],
  actividad_mensual: [
    { mes: "Nov 2025", eventos: 3 },
    { mes: "Dic 2025", eventos: 4 },
    { mes: "Ene 2026", eventos: 5 },
    { mes: "Feb 2026", eventos: 6 },
    { mes: "Mar 2026", eventos: 6 },
    { mes: "Abr 2026", eventos: 6 },
  ],
  quiebres: [
    { fecha: "2026-04-12", descripcion: "Imagen de control (RX rodilla) pendiente post-infiltración >30 días", severidad: "media", accion: "Agendar RX control por call center" },
  ],
  convenios: [
    { nombre: "Cruz Blanca Libre Elección", tipo: "ISAPRE", vigente: true },
  ],
};

export const pacienteSofiaDerma = {
  rut: "55555555-5",
  nombre: "Sofía Dermatología (Amb — Dermatología)",
  edad: 32,
  prevision: "FONASA C",
  centro_habitual: "CM San Joaquín",
  total_eventos: 12,
  resumen_por_ambito: [
    { ambito: "Consulta", count: 4, color: "#06B6D4" },
    { ambito: "Laboratorio", count: 3, color: "#14B8A6" },
    { ambito: "Agenda", count: 3, color: "#8B5CF6" },
    { ambito: "Financiero", count: 2, color: "#EC4899" },
  ],
  eventos: [
    { fecha: "2026-04-02", ambito: "Consulta", descripcion: "Dermatología CMSJ — Resultado biopsia", color: "#06B6D4" },
    { fecha: "2026-03-20", ambito: "Laboratorio", descripcion: "Biopsia piel — resultado benigno", color: "#14B8A6" },
    { fecha: "2026-03-10", ambito: "Consulta", descripcion: "Dermatología — Biopsia lesión", color: "#06B6D4" },
    { fecha: "2026-02-25", ambito: "Agenda", descripcion: "Reserva Dermatología — Web", color: "#8B5CF6" },
    { fecha: "2026-02-10", ambito: "Laboratorio", descripcion: "Hemograma + VHS", color: "#14B8A6" },
    { fecha: "2026-01-28", ambito: "Consulta", descripcion: "Dermatología — Evaluación lesión cutánea", color: "#06B6D4" },
    { fecha: "2026-01-15", ambito: "Pago", descripcion: "Bono FONASA C — aprobado", color: "#EC4899" },
    { fecha: "2026-01-05", ambito: "Agenda", descripcion: "Cita Dermatología — Atendida", color: "#8B5CF6" },
    { fecha: "2025-12-20", ambito: "Consulta", descripcion: "Med Familiar — Derivación dermatología", color: "#06B6D4" },
    { fecha: "2025-11-30", ambito: "Laboratorio", descripcion: "Exámenes generales", color: "#14B8A6" },
  ],
  actividad_mensual: [
    { mes: "Nov 2025", eventos: 1 },
    { mes: "Dic 2025", eventos: 2 },
    { mes: "Ene 2026", eventos: 3 },
    { mes: "Feb 2026", eventos: 2 },
    { mes: "Mar 2026", eventos: 2 },
    { mes: "Abr 2026", eventos: 2 },
  ],
  quiebres: [],
  convenios: [
    { nombre: "FONASA Libre Elección", tipo: "Previsión", vigente: true },
  ],
};

export const pacienteJorgeEndocrino = {
  rut: "66666666-6",
  nombre: "Jorge Endocrinología (Amb — Endocrinología)",
  edad: 58,
  prevision: "ISAPRE Consalud",
  centro_habitual: "CM Lira",
  total_eventos: 35,
  resumen_por_ambito: [
    { ambito: "Consulta", count: 7, color: "#06B6D4" },
    { ambito: "Laboratorio", count: 12, color: "#14B8A6" },
    { ambito: "Imagen", count: 4, color: "#10B981" },
    { ambito: "Agenda", count: 7, color: "#8B5CF6" },
    { ambito: "Financiero", count: 5, color: "#EC4899" },
  ],
  eventos: [
    { fecha: "2026-04-15", ambito: "Consulta", descripcion: "Endocrinología CM Lira — Control DM2", color: "#06B6D4" },
    { fecha: "2026-04-10", ambito: "Laboratorio", descripcion: "TSH + T4 libre", color: "#14B8A6" },
    { fecha: "2026-04-01", ambito: "Laboratorio", descripcion: "Perfil lipídico + Glicemia", color: "#14B8A6" },
    { fecha: "2026-03-20", ambito: "Imagen", descripcion: "Ecografía tiroides", color: "#10B981" },
    { fecha: "2026-03-10", ambito: "Consulta", descripcion: "Endocrinología — Ajuste insulina", color: "#06B6D4" },
    { fecha: "2026-02-25", ambito: "Laboratorio", descripcion: "Hemograma + Creatinina + Microalbuminuria", color: "#14B8A6" },
    { fecha: "2026-02-10", ambito: "Consulta", descripcion: "Endocrinología — Control trimestral", color: "#06B6D4" },
    { fecha: "2026-01-28", ambito: "Laboratorio", descripcion: "Perfil lipídico + Glicemia ayunas", color: "#14B8A6" },
    { fecha: "2026-01-15", ambito: "Imagen", descripcion: "Ecografía tiroides control", color: "#10B981" },
    { fecha: "2026-01-05", ambito: "Agenda", descripcion: "Reserva Endocrinología — Web", color: "#8B5CF6" },
    { fecha: "2025-12-18", ambito: "Consulta", descripcion: "Endocrinología — Control anual", color: "#06B6D4" },
    { fecha: "2025-12-05", ambito: "Laboratorio", descripcion: "TSH + Perfil lipídico", color: "#14B8A6" },
    { fecha: "2025-11-20", ambito: "Pago", descripcion: "Copago Consalud registrado", color: "#EC4899" },
  ],
  actividad_mensual: [
    { mes: "Nov 2025", eventos: 4 },
    { mes: "Dic 2025", eventos: 6 },
    { mes: "Ene 2026", eventos: 7 },
    { mes: "Feb 2026", eventos: 6 },
    { mes: "Mar 2026", eventos: 6 },
    { mes: "Abr 2026", eventos: 6 },
  ],
  quiebres: [
    { fecha: "2026-04-15", descripcion: "HbA1c indicada hace >90 días no realizada — control diabético pendiente", severidad: "alta", accion: "Contacto urgente para agendar lab HbA1c" },
  ],
  convenios: [
    { nombre: "Consalud Libre Elección", tipo: "ISAPRE", vigente: true },
  ],
};

export const pacienteLauraGine = {
  rut: "77777777-7",
  nombre: "Laura Ginecología (Amb — Ginecología)",
  edad: 38,
  prevision: "ISAPRE Colmena",
  centro_habitual: "Clínica San Carlos de Apoquindo",
  total_eventos: 20,
  resumen_por_ambito: [
    { ambito: "Consulta", count: 5, color: "#06B6D4" },
    { ambito: "Laboratorio", count: 4, color: "#14B8A6" },
    { ambito: "Imagen", count: 5, color: "#10B981" },
    { ambito: "Agenda", count: 4, color: "#8B5CF6" },
    { ambito: "Financiero", count: 2, color: "#EC4899" },
  ],
  eventos: [
    { fecha: "2026-04-08", ambito: "Consulta", descripcion: "Ginecología Clínica San Carlos — Control", color: "#06B6D4" },
    { fecha: "2026-04-08", ambito: "Laboratorio", descripcion: "PAP — resultado normal", color: "#14B8A6" },
    { fecha: "2026-03-25", ambito: "Imagen", descripcion: "Ecografía transvaginal", color: "#10B981" },
    { fecha: "2026-03-15", ambito: "Agenda", descripcion: "Reserva Ginecología — Web", color: "#8B5CF6" },
    { fecha: "2026-02-28", ambito: "Consulta", descripcion: "Ginecología — Control anual", color: "#06B6D4" },
    { fecha: "2026-02-15", ambito: "Laboratorio", descripcion: "Perfil hormonal + PAP", color: "#14B8A6" },
    { fecha: "2026-01-30", ambito: "Imagen", descripcion: "Ecografía mamaria bilateral", color: "#10B981" },
    { fecha: "2026-01-15", ambito: "Consulta", descripcion: "Ginecología — Presencial", color: "#06B6D4" },
    { fecha: "2025-12-20", ambito: "Agenda", descripcion: "Cita Ginecología — Atendida", color: "#8B5CF6" },
    { fecha: "2025-12-10", ambito: "Pago", descripcion: "Bono Colmena — aprobado", color: "#EC4899" },
    { fecha: "2025-11-25", ambito: "Consulta", descripcion: "Ginecología — Primera consulta", color: "#06B6D4" },
    { fecha: "2025-11-15", ambito: "Laboratorio", descripcion: "Hemograma + Perfil bioquímico", color: "#14B8A6" },
  ],
  actividad_mensual: [
    { mes: "Nov 2025", eventos: 3 },
    { mes: "Dic 2025", eventos: 3 },
    { mes: "Ene 2026", eventos: 3 },
    { mes: "Feb 2026", eventos: 4 },
    { mes: "Mar 2026", eventos: 3 },
    { mes: "Abr 2026", eventos: 4 },
  ],
  quiebres: [
    { fecha: "2026-03-25", descripcion: "Mamografía indicada en consulta de enero no realizada", severidad: "alta", accion: "Agendar mamografía prioritaria por call center" },
  ],
  convenios: [
    { nombre: "PUC - Colmena Egeo", tipo: "ISAPRE", vigente: true },
    { nombre: "Colmena Libre Elección", tipo: "ISAPRE", vigente: true },
  ],
};

export const pacienteDiegoNeuro = {
  rut: "88888888-8",
  nombre: "Diego Neurología (Amb — Neurología)",
  edad: 70,
  prevision: "FONASA B",
  centro_habitual: "Hospital Clínico UC",
  total_eventos: 28,
  resumen_por_ambito: [
    { ambito: "Consulta", count: 6, color: "#06B6D4" },
    { ambito: "Laboratorio", count: 5, color: "#14B8A6" },
    { ambito: "Imagen", count: 7, color: "#10B981" },
    { ambito: "Agenda", count: 6, color: "#8B5CF6" },
    { ambito: "Financiero", count: 4, color: "#EC4899" },
  ],
  eventos: [
    { fecha: "2026-04-10", ambito: "Consulta", descripcion: "Neurología HCUC — Control", color: "#06B6D4" },
    { fecha: "2026-04-05", ambito: "Laboratorio", descripcion: "Hemograma + Perfil hepático", color: "#14B8A6" },
    { fecha: "2026-03-25", ambito: "Imagen", descripcion: "Electroencefalograma — HCUC", color: "#10B981" },
    { fecha: "2026-03-15", ambito: "Consulta", descripcion: "Neurología — Evaluación cognitiva", color: "#06B6D4" },
    { fecha: "2026-03-01", ambito: "Agenda", descripcion: "Reserva Neurología — Call", color: "#8B5CF6" },
    { fecha: "2026-02-20", ambito: "Laboratorio", descripcion: "Vitamina B12 + Ácido fólico", color: "#14B8A6" },
    { fecha: "2026-02-10", ambito: "Consulta", descripcion: "Neurología — Presencial", color: "#06B6D4" },
    { fecha: "2026-01-25", ambito: "Imagen", descripcion: "Electroencefalograma basal", color: "#10B981" },
    { fecha: "2026-01-15", ambito: "Laboratorio", descripcion: "TSH + Perfil bioquímico", color: "#14B8A6" },
    { fecha: "2026-01-05", ambito: "Consulta", descripcion: "Neurología — Evaluación inicial", color: "#06B6D4" },
    { fecha: "2025-12-20", ambito: "Pago", descripcion: "Bono FONASA B — aprobado", color: "#EC4899" },
    { fecha: "2025-12-10", ambito: "Agenda", descripcion: "Cita Neurología — Atendida", color: "#8B5CF6" },
    { fecha: "2025-11-28", ambito: "Imagen", descripcion: "Scanner cerebral — HCUC", color: "#10B981" },
  ],
  actividad_mensual: [
    { mes: "Nov 2025", eventos: 4 },
    { mes: "Dic 2025", eventos: 5 },
    { mes: "Ene 2026", eventos: 5 },
    { mes: "Feb 2026", eventos: 5 },
    { mes: "Mar 2026", eventos: 5 },
    { mes: "Abr 2026", eventos: 4 },
  ],
  quiebres: [
    { fecha: "2026-04-10", descripcion: "Resonancia magnética cerebral pendiente >45 días desde indicación", severidad: "alta", accion: "Agendar resonancia prioritaria — coordinar con imagenología" },
  ],
  convenios: [
    { nombre: "FONASA Libre Elección", tipo: "Previsión", vigente: true },
  ],
};

// --- HOSPITALARIO ---

export const pacienteCarmenBypass = {
  rut: "10101010-1",
  nombre: "Carmen Cirugía Cardíaca (Hosp — Bypass)",
  edad: 68,
  prevision: "FONASA D",
  centro_habitual: "Hospital Clínico UC",
  total_eventos: 45,
  resumen_por_ambito: [
    { ambito: "Consulta", count: 6, color: "#06B6D4" },
    { ambito: "Laboratorio", count: 8, color: "#14B8A6" },
    { ambito: "Imagen", count: 6, color: "#10B981" },
    { ambito: "Cirugía", count: 4, color: "#84CC16" },
    { ambito: "Hospitalización", count: 10, color: "#F59E0B" },
    { ambito: "Agenda", count: 5, color: "#8B5CF6" },
    { ambito: "Seguimiento", count: 3, color: "#F43F5E" },
    { ambito: "Financiero", count: 3, color: "#EC4899" },
  ],
  eventos: [
    { fecha: "2026-04-15", ambito: "Seguimiento", descripcion: "Control post-operatorio cardíaco — pendiente", color: "#F43F5E" },
    { fecha: "2026-04-02", ambito: "Hospitalización", descripcion: "Alta hospitalaria — día 8 post-bypass", color: "#F59E0B" },
    { fecha: "2026-03-25", ambito: "Cirugía", descripcion: "Bypass coronario triple — Pabellón Cardíaco HCUC", color: "#84CC16" },
    { fecha: "2026-03-25", ambito: "Hospitalización", descripcion: "Ingreso UCI post-quirúrgica", color: "#F59E0B" },
    { fecha: "2026-03-20", ambito: "Laboratorio", descripcion: "Exámenes pre-quirúrgicos completos", color: "#14B8A6" },
    { fecha: "2026-03-18", ambito: "Imagen", descripcion: "ECG pre-operatorio", color: "#10B981" },
    { fecha: "2026-03-15", ambito: "Imagen", descripcion: "Scanner coronario — HCUC", color: "#10B981" },
    { fecha: "2026-03-10", ambito: "Consulta", descripcion: "Cirugía Cardíaca — Evaluación pre-op", color: "#06B6D4" },
    { fecha: "2026-03-01", ambito: "Pago", descripcion: "Presupuesto aprobado FONASA D + GES", color: "#EC4899" },
    { fecha: "2026-02-20", ambito: "Consulta", descripcion: "Cardiología — Coronariografía diagnóstica", color: "#06B6D4" },
    { fecha: "2026-02-10", ambito: "Laboratorio", descripcion: "Troponinas + BNP + Perfil lipídico", color: "#14B8A6" },
    { fecha: "2026-01-25", ambito: "Imagen", descripcion: "Ecocardiograma + Test de esfuerzo", color: "#10B981" },
    { fecha: "2026-01-10", ambito: "Consulta", descripcion: "Cardiología — Evaluación inicial", color: "#06B6D4" },
    { fecha: "2025-12-15", ambito: "Agenda", descripcion: "Reserva Cardiología — Derivación urgente", color: "#8B5CF6" },
  ],
  actividad_mensual: [
    { mes: "Nov 2025", eventos: 3 },
    { mes: "Dic 2025", eventos: 5 },
    { mes: "Ene 2026", eventos: 7 },
    { mes: "Feb 2026", eventos: 8 },
    { mes: "Mar 2026", eventos: 14 },
    { mes: "Abr 2026", eventos: 8 },
  ],
  quiebres: [
    { fecha: "2026-04-15", descripcion: "Control post-operatorio atrasado 5 días (protocolo indica día 10)", severidad: "alta", accion: "Agendar control urgente con cirujano cardíaco" },
  ],
  convenios: [
    { nombre: "FONASA Libre Elección", tipo: "Previsión", vigente: true },
    { nombre: "GES Cardiopatía Coronaria", tipo: "GES", vigente: true },
  ],
};

export const pacienteAndresProtesis = {
  rut: "11011011-1",
  nombre: "Andrés Traumatología Qx (Hosp — Prótesis Rodilla)",
  edad: 65,
  prevision: "ISAPRE Banmédica",
  centro_habitual: "Clínica San Carlos de Apoquindo",
  total_eventos: 38,
  resumen_por_ambito: [
    { ambito: "Consulta", count: 6, color: "#06B6D4" },
    { ambito: "Imagen", count: 6, color: "#10B981" },
    { ambito: "Cirugía", count: 4, color: "#84CC16" },
    { ambito: "Hospitalización", count: 6, color: "#F59E0B" },
    { ambito: "Agenda", count: 5, color: "#8B5CF6" },
    { ambito: "Seguimiento", count: 6, color: "#F43F5E" },
    { ambito: "Financiero", count: 5, color: "#EC4899" },
  ],
  eventos: [
    { fecha: "2026-04-10", ambito: "Seguimiento", descripcion: "Rehabilitación — NO INICIADA", color: "#F43F5E" },
    { fecha: "2026-04-01", ambito: "Hospitalización", descripcion: "Alta hospitalaria — día 5 post-prótesis", color: "#F59E0B" },
    { fecha: "2026-03-27", ambito: "Cirugía", descripcion: "Prótesis total rodilla derecha — Pabellón CSC", color: "#84CC16" },
    { fecha: "2026-03-27", ambito: "Hospitalización", descripcion: "Ingreso pabellón ortopédico", color: "#F59E0B" },
    { fecha: "2026-03-22", ambito: "Laboratorio", descripcion: "Exámenes pre-quirúrgicos", color: "#14B8A6" },
    { fecha: "2026-03-15", ambito: "Pago", descripcion: "Presupuesto aprobado Banmédica Premium", color: "#EC4899" },
    { fecha: "2026-03-05", ambito: "Consulta", descripcion: "Traumatología — Evaluación pre-op", color: "#06B6D4" },
    { fecha: "2026-02-20", ambito: "Imagen", descripcion: "Resonancia magnética rodilla derecha", color: "#10B981" },
    { fecha: "2026-02-10", ambito: "Imagen", descripcion: "RX rodilla AP/Lateral + Eje mecánico", color: "#10B981" },
    { fecha: "2026-01-28", ambito: "Consulta", descripcion: "Traumatología — Indicación quirúrgica", color: "#06B6D4" },
    { fecha: "2026-01-15", ambito: "Consulta", descripcion: "Traumatología — Evaluación inicial", color: "#06B6D4" },
    { fecha: "2025-12-20", ambito: "Agenda", descripcion: "Reserva Traumatología — Web", color: "#8B5CF6" },
    { fecha: "2025-11-30", ambito: "Imagen", descripcion: "RX rodilla — Med Familiar", color: "#10B981" },
  ],
  actividad_mensual: [
    { mes: "Nov 2025", eventos: 3 },
    { mes: "Dic 2025", eventos: 4 },
    { mes: "Ene 2026", eventos: 6 },
    { mes: "Feb 2026", eventos: 6 },
    { mes: "Mar 2026", eventos: 12 },
    { mes: "Abr 2026", eventos: 7 },
  ],
  quiebres: [
    { fecha: "2026-04-10", descripcion: "Rehabilitación kinesiológica no iniciada — protocolo indica inicio día 7 post-op", severidad: "alta", accion: "Agendar kinesiología urgente — coordinar con rehabilitación" },
  ],
  convenios: [
    { nombre: "RED - Banmédica Libre Elección", tipo: "ISAPRE", vigente: true },
    { nombre: "Banmédica Hospitalario Preferente", tipo: "ISAPRE", vigente: true },
  ],
};

export const pacienteIsabelOncoQx = {
  rut: "12012012-1",
  nombre: "Isabel Oncología Qx (Hosp — Mastectomía)",
  edad: 52,
  prevision: "ISAPRE Colmena",
  centro_habitual: "Hospital Clínico UC",
  total_eventos: 55,
  resumen_por_ambito: [
    { ambito: "Consulta", count: 8, color: "#06B6D4" },
    { ambito: "Laboratorio", count: 10, color: "#14B8A6" },
    { ambito: "Imagen", count: 6, color: "#10B981" },
    { ambito: "Cirugía", count: 4, color: "#84CC16" },
    { ambito: "Hospitalización", count: 8, color: "#F59E0B" },
    { ambito: "Agenda", count: 7, color: "#8B5CF6" },
    { ambito: "Seguimiento", count: 8, color: "#F43F5E" },
    { ambito: "Financiero", count: 4, color: "#EC4899" },
  ],
  eventos: [
    { fecha: "2026-04-15", ambito: "Seguimiento", descripcion: "Quimioterapia ciclo 3 — ATRASADO", color: "#F43F5E" },
    { fecha: "2026-04-05", ambito: "Laboratorio", descripcion: "Hemograma + Marcadores tumorales (CA 15-3)", color: "#14B8A6" },
    { fecha: "2026-03-28", ambito: "Seguimiento", descripcion: "Quimioterapia ciclo 2 — completado", color: "#F43F5E" },
    { fecha: "2026-03-15", ambito: "Seguimiento", descripcion: "Quimioterapia ciclo 1 — completado", color: "#F43F5E" },
    { fecha: "2026-03-10", ambito: "Consulta", descripcion: "Oncología — Inicio quimioterapia", color: "#06B6D4" },
    { fecha: "2026-03-01", ambito: "Hospitalización", descripcion: "Alta hospitalaria — día 4 post-mastectomía", color: "#F59E0B" },
    { fecha: "2026-02-25", ambito: "Cirugía", descripcion: "Mastectomía radical modificada — Pabellón HCUC", color: "#84CC16" },
    { fecha: "2026-02-25", ambito: "Hospitalización", descripcion: "Ingreso pabellón oncológico", color: "#F59E0B" },
    { fecha: "2026-02-18", ambito: "Consulta", descripcion: "Comité Oncológico — Decisión quirúrgica + QT", color: "#06B6D4" },
    { fecha: "2026-02-10", ambito: "Laboratorio", descripcion: "Biopsia core — Carcinoma ductal invasor", color: "#14B8A6" },
    { fecha: "2026-02-01", ambito: "Imagen", descripcion: "Mamografía + Ecografía mamaria", color: "#10B981" },
    { fecha: "2026-01-20", ambito: "Consulta", descripcion: "Mastología — Evaluación nódulo", color: "#06B6D4" },
    { fecha: "2026-01-10", ambito: "Imagen", descripcion: "Mamografía screening — hallazgo BIRADS 4", color: "#10B981" },
    { fecha: "2025-12-15", ambito: "Agenda", descripcion: "Reserva Mastología — Urgente", color: "#8B5CF6" },
  ],
  actividad_mensual: [
    { mes: "Nov 2025", eventos: 3 },
    { mes: "Dic 2025", eventos: 5 },
    { mes: "Ene 2026", eventos: 8 },
    { mes: "Feb 2026", eventos: 14 },
    { mes: "Mar 2026", eventos: 15 },
    { mes: "Abr 2026", eventos: 10 },
  ],
  quiebres: [
    { fecha: "2026-04-15", descripcion: "Quimioterapia ciclo 3 atrasado >10 días — riesgo de interrupción protocolo", severidad: "alta", accion: "Coordinar con oncología para reagendar ciclo 3 urgente" },
    { fecha: "2026-04-05", descripcion: "Marcadores tumorales post-QT pendientes de revisión", severidad: "media", accion: "Verificar resultados con oncólogo tratante" },
  ],
  convenios: [
    { nombre: "PUC - Colmena Egeo", tipo: "ISAPRE", vigente: true },
    { nombre: "GES Cáncer de Mama", tipo: "GES", vigente: true },
    { nombre: "Colmena Hospitalario Preferente", tipo: "ISAPRE", vigente: true },
  ],
};

// --- URGENCIA ---

export const pacienteFelipeUrgAdulto = {
  rut: "13013013-1",
  nombre: "Felipe Urgencia Adulto (Urg — Dolor Torácico)",
  edad: 50,
  prevision: "FONASA C",
  centro_habitual: "Hospital Clínico UC",
  total_eventos: 15,
  resumen_por_ambito: [
    { ambito: "Consulta", count: 3, color: "#06B6D4" },
    { ambito: "Laboratorio", count: 4, color: "#14B8A6" },
    { ambito: "Imagen", count: 3, color: "#10B981" },
    { ambito: "Agenda", count: 2, color: "#8B5CF6" },
    { ambito: "Seguimiento", count: 3, color: "#F43F5E" },
  ],
  eventos: [
    { fecha: "2026-03-20", ambito: "Seguimiento", descripcion: "Alta urgencia — dolor torácico descartado cardíaco", color: "#F43F5E" },
    { fecha: "2026-03-20", ambito: "Laboratorio", descripcion: "Troponinas seriadas — negativas", color: "#14B8A6" },
    { fecha: "2026-03-20", ambito: "Laboratorio", descripcion: "Troponinas T — primera muestra", color: "#14B8A6" },
    { fecha: "2026-03-20", ambito: "Imagen", descripcion: "ECG urgencia — sin alteraciones ST", color: "#10B981" },
    { fecha: "2026-03-20", ambito: "Consulta", descripcion: "Urgencia HCUC — Triage C3 dolor torácico", color: "#06B6D4" },
    { fecha: "2026-03-20", ambito: "Agenda", descripcion: "Llegada Urgencia — Admisión", color: "#8B5CF6" },
    { fecha: "2026-03-20", ambito: "Seguimiento", descripcion: "Observación 6 horas — estable", color: "#F43F5E" },
    { fecha: "2026-03-20", ambito: "Imagen", descripcion: "Radiografía tórax — normal", color: "#10B981" },
    { fecha: "2026-03-20", ambito: "Laboratorio", descripcion: "Hemograma + PCR + Dímero D", color: "#14B8A6" },
    { fecha: "2026-03-20", ambito: "Pago", descripcion: "Bono FONASA C urgencia — aprobado", color: "#EC4899" },
  ],
  actividad_mensual: [
    { mes: "Nov 2025", eventos: 0 },
    { mes: "Dic 2025", eventos: 0 },
    { mes: "Ene 2026", eventos: 0 },
    { mes: "Feb 2026", eventos: 0 },
    { mes: "Mar 2026", eventos: 15 },
    { mes: "Abr 2026", eventos: 0 },
  ],
  quiebres: [],
  convenios: [
    { nombre: "FONASA Libre Elección", tipo: "Previsión", vigente: true },
  ],
};

export const pacienteValentinaUrgPed = {
  rut: "14014014-1",
  nombre: "Valentina Urgencia Pediátrica (Urg — Fractura)",
  edad: 10,
  prevision: "ISAPRE Cruz Blanca",
  centro_habitual: "Clínica San Carlos de Apoquindo",
  total_eventos: 12,
  resumen_por_ambito: [
    { ambito: "Consulta", count: 3, color: "#06B6D4" },
    { ambito: "Imagen", count: 3, color: "#10B981" },
    { ambito: "Agenda", count: 2, color: "#8B5CF6" },
    { ambito: "Seguimiento", count: 2, color: "#F43F5E" },
    { ambito: "Financiero", count: 2, color: "#EC4899" },
  ],
  eventos: [
    { fecha: "2026-03-28", ambito: "Seguimiento", descripcion: "Control traumatología 4 semanas — NO AGENDADO", color: "#F43F5E" },
    { fecha: "2026-03-01", ambito: "Seguimiento", descripcion: "Alta urgencia con yeso antebrazo", color: "#F43F5E" },
    { fecha: "2026-03-01", ambito: "Consulta", descripcion: "Urgencia Ped CSC — Reducción fractura + yeso", color: "#06B6D4" },
    { fecha: "2026-03-01", ambito: "Imagen", descripcion: "RX antebrazo AP/Lateral — Fractura diáfisis radio", color: "#10B981" },
    { fecha: "2026-03-01", ambito: "Consulta", descripcion: "Urgencia Pediátrica CSC — Triage C2 trauma", color: "#06B6D4" },
    { fecha: "2026-03-01", ambito: "Agenda", descripcion: "Llegada Urgencia Pediátrica — Admisión", color: "#8B5CF6" },
    { fecha: "2026-03-01", ambito: "Imagen", descripcion: "RX control post-reducción — alineación OK", color: "#10B981" },
    { fecha: "2026-03-01", ambito: "Pago", descripcion: "Bono Cruz Blanca urgencia — aprobado", color: "#EC4899" },
  ],
  actividad_mensual: [
    { mes: "Nov 2025", eventos: 0 },
    { mes: "Dic 2025", eventos: 0 },
    { mes: "Ene 2026", eventos: 0 },
    { mes: "Feb 2026", eventos: 0 },
    { mes: "Mar 2026", eventos: 12 },
    { mes: "Abr 2026", eventos: 0 },
  ],
  quiebres: [
    { fecha: "2026-03-28", descripcion: "Control traumatología a 4 semanas no agendado — riesgo consolidación", severidad: "alta", accion: "Contactar apoderado por WhatsApp para agendar control + RX" },
  ],
  convenios: [
    { nombre: "Cruz Blanca Libre Elección", tipo: "ISAPRE", vigente: true },
  ],
};

export const pacienteManuelUrgHosp = {
  rut: "15015015-1",
  nombre: "Manuel Urgencia → Hospitalización (Urg — Apendicitis)",
  edad: 28,
  prevision: "ISAPRE Consalud",
  centro_habitual: "Hospital Clínico UC",
  total_eventos: 25,
  resumen_por_ambito: [
    { ambito: "Consulta", count: 4, color: "#06B6D4" },
    { ambito: "Laboratorio", count: 5, color: "#14B8A6" },
    { ambito: "Imagen", count: 3, color: "#10B981" },
    { ambito: "Cirugía", count: 3, color: "#84CC16" },
    { ambito: "Hospitalización", count: 4, color: "#F59E0B" },
    { ambito: "Agenda", count: 2, color: "#8B5CF6" },
    { ambito: "Seguimiento", count: 2, color: "#F43F5E" },
    { ambito: "Financiero", count: 2, color: "#EC4899" },
  ],
  eventos: [
    { fecha: "2026-04-05", ambito: "Seguimiento", descripcion: "Control post-operatorio — PENDIENTE", color: "#F43F5E" },
    { fecha: "2026-03-22", ambito: "Hospitalización", descripcion: "Alta hospitalaria — día 3 post-apendicectomía", color: "#F59E0B" },
    { fecha: "2026-03-19", ambito: "Cirugía", descripcion: "Apendicectomía laparoscópica urgente — HCUC", color: "#84CC16" },
    { fecha: "2026-03-19", ambito: "Hospitalización", descripcion: "Ingreso pabellón urgente", color: "#F59E0B" },
    { fecha: "2026-03-19", ambito: "Imagen", descripcion: "Scanner abdomen — Apendicitis aguda", color: "#10B981" },
    { fecha: "2026-03-19", ambito: "Laboratorio", descripcion: "Hemograma + PCR + Orina completa", color: "#14B8A6" },
    { fecha: "2026-03-19", ambito: "Consulta", descripcion: "Urgencia HCUC — Evaluación cirugía", color: "#06B6D4" },
    { fecha: "2026-03-19", ambito: "Consulta", descripcion: "Urgencia HCUC — Triage C2 dolor abdominal", color: "#06B6D4" },
    { fecha: "2026-03-19", ambito: "Agenda", descripcion: "Llegada Urgencia — Admisión", color: "#8B5CF6" },
    { fecha: "2026-03-19", ambito: "Pago", descripcion: "Ley de Urgencia — activada", color: "#EC4899" },
    { fecha: "2026-03-20", ambito: "Laboratorio", descripcion: "Hemograma control post-op", color: "#14B8A6" },
    { fecha: "2026-03-21", ambito: "Consulta", descripcion: "Visita cirujano — evolución favorable", color: "#06B6D4" },
  ],
  actividad_mensual: [
    { mes: "Nov 2025", eventos: 0 },
    { mes: "Dic 2025", eventos: 0 },
    { mes: "Ene 2026", eventos: 0 },
    { mes: "Feb 2026", eventos: 0 },
    { mes: "Mar 2026", eventos: 22 },
    { mes: "Abr 2026", eventos: 3 },
  ],
  quiebres: [
    { fecha: "2026-04-05", descripcion: "Control post-operatorio pendiente — protocolo indica día 10 post-op", severidad: "alta", accion: "Agendar control cirugía urgente por call center" },
  ],
  convenios: [
    { nombre: "Consalud Libre Elección", tipo: "ISAPRE", vigente: true },
    { nombre: "Ley Urgencia", tipo: "Legal", vigente: true },
  ],
};

// --- ONCOLÓGICO ---

export const pacienteRosaOncoMama = {
  rut: "17017017-1",
  nombre: "Rosa Oncología (Onco — Cáncer Mama)",
  edad: 48,
  prevision: "ISAPRE Colmena",
  centro_habitual: "Hospital Clínico UC",
  total_eventos: 60,
  resumen_por_ambito: [
    { ambito: "Consulta", count: 8, color: "#06B6D4" },
    { ambito: "Laboratorio", count: 12, color: "#14B8A6" },
    { ambito: "Imagen", count: 8, color: "#10B981" },
    { ambito: "Cirugía", count: 3, color: "#84CC16" },
    { ambito: "Hospitalización", count: 6, color: "#F59E0B" },
    { ambito: "Seguimiento", count: 14, color: "#F43F5E" },
    { ambito: "Agenda", count: 5, color: "#8B5CF6" },
    { ambito: "Financiero", count: 4, color: "#EC4899" },
  ],
  eventos: [
    { fecha: "2026-04-18", ambito: "Seguimiento", descripcion: "Radioterapia sesión 8/25 — PENDIENTE", color: "#F43F5E" },
    { fecha: "2026-04-15", ambito: "Seguimiento", descripcion: "Radioterapia sesión 7/25 — completada", color: "#F43F5E" },
    { fecha: "2026-04-12", ambito: "Seguimiento", descripcion: "Radioterapia sesión 6/25 — completada", color: "#F43F5E" },
    { fecha: "2026-04-08", ambito: "Laboratorio", descripcion: "Hemograma + Marcadores tumorales (CA 15-3)", color: "#14B8A6" },
    { fecha: "2026-04-01", ambito: "Consulta", descripcion: "Oncología — Inicio radioterapia", color: "#06B6D4" },
    { fecha: "2026-03-20", ambito: "Cirugía", descripcion: "Mastectomía parcial + Ganglio centinela — HCUC", color: "#84CC16" },
    { fecha: "2026-03-20", ambito: "Hospitalización", descripcion: "Ingreso pabellón oncológico", color: "#F59E0B" },
    { fecha: "2026-03-10", ambito: "Seguimiento", descripcion: "Quimioterapia ciclo 6/6 — completado", color: "#F43F5E" },
    { fecha: "2026-02-25", ambito: "Seguimiento", descripcion: "Quimioterapia ciclo 5/6 — completado", color: "#F43F5E" },
    { fecha: "2026-02-10", ambito: "Seguimiento", descripcion: "Quimioterapia ciclo 4/6 — completado", color: "#F43F5E" },
    { fecha: "2026-01-28", ambito: "Laboratorio", descripcion: "Hemograma inter-ciclo + Función hepática", color: "#14B8A6" },
    { fecha: "2026-01-20", ambito: "Seguimiento", descripcion: "Quimioterapia ciclo 3/6 — completado", color: "#F43F5E" },
    { fecha: "2026-01-05", ambito: "Consulta", descripcion: "Comité Oncológico — Plan QT neoadyuvante + Cirugía + RT", color: "#06B6D4" },
    { fecha: "2025-12-20", ambito: "Laboratorio", descripcion: "Biopsia core — Carcinoma ductal invasor HER2+", color: "#14B8A6" },
    { fecha: "2025-12-10", ambito: "Imagen", descripcion: "Mamografía + Ecografía — BIRADS 5", color: "#10B981" },
    { fecha: "2025-11-25", ambito: "Consulta", descripcion: "Mastología — Evaluación nódulo palpable", color: "#06B6D4" },
  ],
  actividad_mensual: [
    { mes: "Nov 2025", eventos: 4 },
    { mes: "Dic 2025", eventos: 8 },
    { mes: "Ene 2026", eventos: 12 },
    { mes: "Feb 2026", eventos: 10 },
    { mes: "Mar 2026", eventos: 14 },
    { mes: "Abr 2026", eventos: 12 },
  ],
  quiebres: [
    { fecha: "2026-04-18", descripcion: "Radioterapia sesión 8 pendiente — riesgo interrupción protocolo RT", severidad: "alta", accion: "Coordinar con radioterapia para reagendar sesión 8 urgente" },
    { fecha: "2026-04-08", descripcion: "Marcadores tumorales post-QT pendientes de revisión oncológica", severidad: "media", accion: "Verificar resultados con oncólogo tratante" },
  ],
  convenios: [
    { nombre: "PUC - Colmena Egeo", tipo: "ISAPRE", vigente: true },
    { nombre: "GES Cáncer de Mama", tipo: "GES", vigente: true },
    { nombre: "Colmena Hospitalario Preferente", tipo: "ISAPRE", vigente: true },
  ],
};

// --- DIÁLISIS ---

export const pacienteEduardoDialisis = {
  rut: "18018018-1",
  nombre: "Eduardo Diálisis (Diálisis — Hemodiálisis)",
  edad: 72,
  prevision: "FONASA D",
  centro_habitual: "Hospital Clínico UC",
  total_eventos: 40,
  resumen_por_ambito: [
    { ambito: "Consulta", count: 4, color: "#06B6D4" },
    { ambito: "Laboratorio", count: 8, color: "#14B8A6" },
    { ambito: "Seguimiento", count: 20, color: "#F43F5E" },
    { ambito: "Agenda", count: 4, color: "#8B5CF6" },
    { ambito: "Financiero", count: 4, color: "#EC4899" },
  ],
  eventos: [
    { fecha: "2026-04-15", ambito: "Seguimiento", descripcion: "Hemodiálisis sesión — Lun/Mié/Vie", color: "#F43F5E" },
    { fecha: "2026-04-12", ambito: "Seguimiento", descripcion: "Hemodiálisis sesión — Lun/Mié/Vie", color: "#F43F5E" },
    { fecha: "2026-04-10", ambito: "Seguimiento", descripcion: "Hemodiálisis sesión — Lun/Mié/Vie", color: "#F43F5E" },
    { fecha: "2026-04-08", ambito: "Seguimiento", descripcion: "Administración EPO subcutánea", color: "#F43F5E" },
    { fecha: "2026-04-05", ambito: "Seguimiento", descripcion: "Hemodiálisis sesión — Lun/Mié/Vie", color: "#F43F5E" },
    { fecha: "2026-03-28", ambito: "Consulta", descripcion: "Nefrología HCUC — Control mensual", color: "#06B6D4" },
    { fecha: "2026-03-20", ambito: "Seguimiento", descripcion: "Hemodiálisis sesión — Lun/Mié/Vie", color: "#F43F5E" },
    { fecha: "2026-03-15", ambito: "Seguimiento", descripcion: "Administración EPO subcutánea", color: "#F43F5E" },
    { fecha: "2026-02-28", ambito: "Laboratorio", descripcion: "Creatinina + BUN + Electrolitos + Hemograma", color: "#14B8A6" },
    { fecha: "2026-02-15", ambito: "Consulta", descripcion: "Nefrología — Control mensual", color: "#06B6D4" },
    { fecha: "2026-01-30", ambito: "Laboratorio", descripcion: "Creatinina + BUN + Fósforo + Calcio", color: "#14B8A6" },
    { fecha: "2026-01-15", ambito: "Consulta", descripcion: "Nefrología — Control mensual", color: "#06B6D4" },
    { fecha: "2025-12-20", ambito: "Laboratorio", descripcion: "Perfil renal completo + PTH", color: "#14B8A6" },
    { fecha: "2025-11-28", ambito: "Laboratorio", descripcion: "Creatinina + BUN + Hemograma", color: "#14B8A6" },
  ],
  actividad_mensual: [
    { mes: "Nov 2025", eventos: 14 },
    { mes: "Dic 2025", eventos: 14 },
    { mes: "Ene 2026", eventos: 15 },
    { mes: "Feb 2026", eventos: 14 },
    { mes: "Mar 2026", eventos: 15 },
    { mes: "Abr 2026", eventos: 14 },
  ],
  quiebres: [
    { fecha: "2026-04-15", descripcion: "Lab de control mensual (Creatinina/BUN/Electrolitos) atrasado >30 días", severidad: "alta", accion: "Coordinar toma de muestra en próxima sesión de hemodiálisis" },
  ],
  convenios: [
    { nombre: "FONASA Libre Elección", tipo: "Previsión", vigente: true },
    { nombre: "GES Insuficiencia Renal Crónica Terminal", tipo: "GES", vigente: true },
  ],
};

// --- MULTI-VIAJE ---

export const pacientePatriciaMulti = {
  rut: "19019019-1",
  nombre: "Patricia Multi-viaje (Amb+Hosp — Diabetes+Cirugía)",
  edad: 60,
  prevision: "ISAPRE Banmédica",
  centro_habitual: "CM San Joaquín",
  total_eventos: 50,
  resumen_por_ambito: [
    { ambito: "Consulta", count: 10, color: "#06B6D4" },
    { ambito: "Laboratorio", count: 12, color: "#14B8A6" },
    { ambito: "Imagen", count: 5, color: "#10B981" },
    { ambito: "Cirugía", count: 3, color: "#84CC16" },
    { ambito: "Hospitalización", count: 4, color: "#F59E0B" },
    { ambito: "Agenda", count: 8, color: "#8B5CF6" },
    { ambito: "Seguimiento", count: 4, color: "#F43F5E" },
    { ambito: "Financiero", count: 4, color: "#EC4899" },
  ],
  eventos: [
    { fecha: "2026-04-15", ambito: "Seguimiento", descripcion: "Control post-cirugía cataratas — PENDIENTE", color: "#F43F5E" },
    { fecha: "2026-04-10", ambito: "Consulta", descripcion: "Endocrinología CMSJ — Control DM2", color: "#06B6D4" },
    { fecha: "2026-04-01", ambito: "Hospitalización", descripcion: "Alta — cirugía cataratas ambulatoria", color: "#F59E0B" },
    { fecha: "2026-04-01", ambito: "Cirugía", descripcion: "Facoemulsificación ojo derecho — CSC", color: "#84CC16" },
    { fecha: "2026-03-25", ambito: "Laboratorio", descripcion: "Exámenes pre-quirúrgicos + HbA1c", color: "#14B8A6" },
    { fecha: "2026-03-15", ambito: "Consulta", descripcion: "Oftalmología — Evaluación pre-op cataratas", color: "#06B6D4" },
    { fecha: "2026-03-05", ambito: "Imagen", descripcion: "Biometría ocular pre-cirugía", color: "#10B981" },
    { fecha: "2026-02-25", ambito: "Consulta", descripcion: "Endocrinología — Ajuste metformina", color: "#06B6D4" },
    { fecha: "2026-02-15", ambito: "Laboratorio", descripcion: "Perfil lipídico + Glicemia + Creatinina", color: "#14B8A6" },
    { fecha: "2026-02-01", ambito: "Consulta", descripcion: "Oftalmología — Diagnóstico cataratas", color: "#06B6D4" },
    { fecha: "2026-01-20", ambito: "Laboratorio", descripcion: "HbA1c + Perfil lipídico", color: "#14B8A6" },
    { fecha: "2026-01-10", ambito: "Consulta", descripcion: "Endocrinología — Control trimestral", color: "#06B6D4" },
    { fecha: "2025-12-15", ambito: "Imagen", descripcion: "Fondo de ojo — Retinopatía diabética leve", color: "#10B981" },
    { fecha: "2025-12-01", ambito: "Laboratorio", descripcion: "Hemograma + Microalbuminuria", color: "#14B8A6" },
    { fecha: "2025-11-20", ambito: "Consulta", descripcion: "Endocrinología — Control DM2", color: "#06B6D4" },
  ],
  actividad_mensual: [
    { mes: "Nov 2025", eventos: 5 },
    { mes: "Dic 2025", eventos: 7 },
    { mes: "Ene 2026", eventos: 8 },
    { mes: "Feb 2026", eventos: 9 },
    { mes: "Mar 2026", eventos: 10 },
    { mes: "Abr 2026", eventos: 11 },
  ],
  quiebres: [
    { fecha: "2026-04-15", descripcion: "HbA1c indicada hace >90 días no realizada — control diabético pendiente", severidad: "alta", accion: "Agendar lab HbA1c urgente antes de próximo control endocrino" },
    { fecha: "2026-04-15", descripcion: "Control post-cirugía cataratas pendiente — protocolo indica día 7", severidad: "alta", accion: "Agendar control oftalmología urgente" },
  ],
  convenios: [
    { nombre: "RED - Banmédica Libre Elección", tipo: "ISAPRE", vigente: true },
    { nombre: "Banmédica Hospitalario Preferente", tipo: "ISAPRE", vigente: true },
  ],
};

export const pacienteTomasCronico = {
  rut: "20020020-1",
  nombre: "Tomás Crónico (Amb — Hipertensión+Diabetes)",
  edad: 75,
  prevision: "FONASA D",
  centro_habitual: "CM Lira",
  total_eventos: 45,
  resumen_por_ambito: [
    { ambito: "Consulta", count: 10, color: "#06B6D4" },
    { ambito: "Laboratorio", count: 14, color: "#14B8A6" },
    { ambito: "Imagen", count: 3, color: "#10B981" },
    { ambito: "Agenda", count: 8, color: "#8B5CF6" },
    { ambito: "Seguimiento", count: 6, color: "#F43F5E" },
    { ambito: "Financiero", count: 4, color: "#EC4899" },
  ],
  eventos: [
    { fecha: "2026-04-12", ambito: "Consulta", descripcion: "Med Familiar CM Lira — Control crónico", color: "#06B6D4" },
    { fecha: "2026-04-05", ambito: "Laboratorio", descripcion: "Perfil lipídico + Glicemia + Creatinina", color: "#14B8A6" },
    { fecha: "2026-04-01", ambito: "Seguimiento", descripcion: "Retiro medicamentos crónicos — Farmacia", color: "#F43F5E" },
    { fecha: "2026-03-20", ambito: "Consulta", descripcion: "Endocrinología CM Lira — Control DM2", color: "#06B6D4" },
    { fecha: "2026-03-10", ambito: "Laboratorio", descripcion: "HbA1c + Microalbuminuria", color: "#14B8A6" },
    { fecha: "2026-03-01", ambito: "Seguimiento", descripcion: "Retiro medicamentos crónicos — Farmacia", color: "#F43F5E" },
    { fecha: "2026-02-20", ambito: "Consulta", descripcion: "Med Familiar — Control presión arterial", color: "#06B6D4" },
    { fecha: "2026-02-10", ambito: "Laboratorio", descripcion: "Perfil lipídico + Electrolitos", color: "#14B8A6" },
    { fecha: "2026-02-01", ambito: "Seguimiento", descripcion: "Retiro medicamentos crónicos — Farmacia", color: "#F43F5E" },
    { fecha: "2026-01-15", ambito: "Consulta", descripcion: "Endocrinología — Control trimestral DM2", color: "#06B6D4" },
    { fecha: "2026-01-05", ambito: "Laboratorio", descripcion: "Hemograma + Perfil bioquímico completo", color: "#14B8A6" },
    { fecha: "2025-12-20", ambito: "Imagen", descripcion: "ECG de reposo — control HTA", color: "#10B981" },
    { fecha: "2025-12-10", ambito: "Consulta", descripcion: "Med Familiar — Control crónico", color: "#06B6D4" },
    { fecha: "2025-11-25", ambito: "Laboratorio", descripcion: "Perfil lipídico + Glicemia + HbA1c", color: "#14B8A6" },
    { fecha: "2025-11-15", ambito: "Pago", descripcion: "Bono FONASA D — aprobado", color: "#EC4899" },
  ],
  actividad_mensual: [
    { mes: "Nov 2025", eventos: 6 },
    { mes: "Dic 2025", eventos: 7 },
    { mes: "Ene 2026", eventos: 8 },
    { mes: "Feb 2026", eventos: 8 },
    { mes: "Mar 2026", eventos: 8 },
    { mes: "Abr 2026", eventos: 8 },
  ],
  quiebres: [
    { fecha: "2026-04-12", descripcion: "Control cardiología pendiente >6 meses — riesgo cardiovascular alto", severidad: "alta", accion: "Agendar control cardiología urgente — paciente HTA + DM2" },
    { fecha: "2026-04-05", descripcion: "Ecocardiograma de control anual no realizado", severidad: "media", accion: "Coordinar imagen cardíaca con cardiología" },
  ],
  convenios: [
    { nombre: "FONASA Libre Elección", tipo: "Previsión", vigente: true },
    { nombre: "Programa Cardiovascular FONASA", tipo: "Programa", vigente: true },
  ],
};
